function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.621 18.5c-1.463 0-2.716-.49-3.759-1.47-1.043-.979-1.564-2.185-1.564-3.617 0-1.431.521-2.636 1.564-3.612 1.043-.976 2.296-1.465 3.76-1.465h7.02L13.86 5.554 14.914 4.5 19.5 9.086l-4.586 4.587-1.054-1.054 2.782-2.783h-7.02c-1.044 0-1.943.343-2.695 1.03-.753.685-1.129 1.535-1.129 2.548 0 1.012.376 1.863 1.129 2.552.752.69 1.65 1.034 2.694 1.034h7.177v1.5H9.621z",
  fill: "#474747"
})));